export default __webpack_public_path__ + "static/media/customDomain.60afb1f7.png";